import FilterCheckboxChip from './FilterCheckboxChip';
import FilterSelect from '../Input/FilterSelect';
import { formatVolume } from '../../../utils/helpers';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import styled from 'styled-components';
import { useFetchMostPopularAffinityRoots } from 'utils/hooks';
import { withMixpanelChange } from 'utils/app';

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const AffinityFilterChipsUntracked = ({
    children,
    appliedFilters,
    onChange,
    queryData,
    filterNames,
    filters,
    setFilters,
    setFilter,
    filtersSansHealthStats,
    getOnChange,
    menus,
    mixpanelMeta,
    ...props
}) => {
    const { data, NoOptionsMessage, ...restQuery } =
        useFetchMostPopularAffinityRoots(queryData);
    const resetMenuFilters = () => {
        const cluster =
            filterNames.includes('parentName') ||
            filterNames.includes('tikTokParentName') ||
            filterNames.includes('healthStats')
                ? []
                : (filters.cluster || []).filter(({ value }) =>
                      value.includes('ris'),
                  );
        const parentName = (filters.parentName || []).filter(({ value }) =>
            data?.map(({ value }) => value).includes(value),
        );
        const nextFilters = {};

        if (cluster.length) {
            nextFilters.cluster = cluster;
        }

        if (parentName.length) {
            nextFilters.parentName = parentName;
        }

        setFilters(nextFilters);
    };
    return (
        <Wrapper {...props}>
            {menus && menus.length ? (
                <span id="data-table-filter-select">
                    <FilterSelect
                        filters={filtersSansHealthStats}
                        setFilter={setFilter}
                        resetFilters={resetMenuFilters}
                        mixpanelMeta={mixpanelMeta}
                        menus={menus}
                        getOnChange={getOnChange}
                        menuAlign="left"
                        queryData={queryData}
                        appliedFilterChipCount={data?.reduce(
                            (acc, { value }) =>
                                acc + (appliedFilters?.includes(value) ? 1 : 0),
                            0,
                        )}
                    />
                </span>
            ) : null}
            {data && data.length ? (
                data.map((option) => {
                    const { label, value, volume } = option;
                    const checked =
                        !!appliedFilters && appliedFilters.includes(value);

                    return (
                        <FilterCheckboxChip
                            checked={checked}
                            onChange={() =>
                                onChange({
                                    action: checked
                                        ? 'remove-value'
                                        : 'select-option',
                                    option,
                                })
                            }
                            preserveIconSpace={false}
                            key={label}
                        >
                            <span>
                                <span>
                                    {label}{' '}
                                    <span
                                        css={`
                                            font-weight: 500;
                                            margin-left: 0.5rem;
                                            color: ${({ theme }) =>
                                                theme.gray_600};
                                            text-transform: uppercase;
                                        `}
                                    >
                                        {formatVolume(volume)}
                                    </span>
                                </span>
                            </span>
                        </FilterCheckboxChip>
                    );
                })
            ) : (
                <span>
                    <NoOptionsMessage {...restQuery} />
                </span>
            )}
        </Wrapper>
    );
};

const AffinityFilterChipsWithMixpanel = withMixpanelChange(
    AffinityFilterChipsUntracked,
    'AffinityFilterChips',
);

export const AffinityFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'GroupFilterSelect',
    ...props
}) => {
    return (
        <AffinityFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default AffinityFilterChips;
